// Builds the /api/notify payload for a home valuation lead. Used both when the
// estimate succeeds and when it fails — the visitor has already given us their
// name, email and address, so a failed estimate must not also lose the lead.
export const CONDITION_LABELS = {
  excellent: 'Excellent',
  good: 'Good',
  fair: 'Fair',
  poor: 'Poor / Needs Work',
};

export function formatPriceFull(n) {
  return '$' + n.toLocaleString();
}

export function buildValuationLead(formData, source, { estimate, error } = {}) {
  const sqft = parseInt(formData.sqft);
  const lead = {
    type: 'valuation',
    source,
    first_name: formData.first_name,
    last_name: formData.last_name,
    email: formData.email,
    address: formData.address,
    condition: CONDITION_LABELS[formData.condition],
    sqft: sqft || 'Not provided',
    beds: formData.beds || 'Not provided',
    baths: formData.baths || 'Not provided',
  };

  if (estimate) {
    lead.estimate_low = formatPriceFull(estimate.low);
    lead.estimate_high = formatPriceFull(estimate.high);
    lead.reasoning = estimate.reasoning;
  }
  if (error) lead.estimate_error = error;

  return lead;
}
